import React from 'react'
import { Dialog } from '@enterprise-ui/canvas-ui-react'
import { useGlobalForm } from '../Context/GlobalFormStateContext'
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { SET_FIELD } from './Constants'
import { FormikValues } from 'formik'
import moment from 'moment'

const headingSize = css`
  .C-Heading.\--size-h4 {
    font-size: 15px;
  }
`

interface MainProp {
  duration?: any
  formik?: FormikValues
}

const DocValidationDateCheck: React.FC<MainProp> = (props) => {
  const [state, dispatch] = useGlobalForm()
  const { formik, duration } = props

  const heading = state.paymentPaid
    ? 'Document Already Paid'
    : state.invoiceDueDateFlag
      ? 'Dispute cannot be created as invoice is not yet due'
      : state.docCreateDateFlag
        ? `Dispute can be raised only within ${duration} months from the Invoice/Chargeback date`
        : ''

  // Format date function to display dates in MM/DD/YYYY format
  const formatDate = (dateString: string | undefined | null): string => {
    if (!dateString) return ''
    return moment(dateString).format('MM/DD/YYYY')
  }

  const paymentMessage =
    'This document has already been fully paid with the following details: ' +
    ' Payment Number: ' +
    (formik?.values.originalCheckNumber || 'N/A') +
    ' , Amount: $' +
    (formik?.values.originalCheckAmount || 'N/A') +
    ' , Payment Date: ' +
    (formatDate(formik?.values.originalCheckDate) || 'N/A') +
    '. Hence, a dispute cannot be submitted.'

  return (
    <Dialog
      css={headingSize}
      headingText={heading}
      bodyText={state.paymentPaid ? paymentMessage : ''}
      approveButtonText="OK"
      onApprove={() => {
        dispatch({
          type: SET_FIELD,
          payload: [
            { id: 'invoiceDueDateFlag', value: false },
            { id: 'docCreateDateFlag', value: false },
            { id: 'paymentPaid', value: false },
            { id: 'isDocNextFlag', value: false },
          ],
        })
      }}
      isVisible={
        state.invoiceDueDateFlag || state.docCreateDateFlag || state.paymentPaid
      }
    />
  )
}

export default DocValidationDateCheck
